import helperStyles from "@src/components/helpers.module.scss";
import React from "react";

export const Venue: React.FC = () => {
	return (
		<div className={helperStyles.iconContainer}>
			<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 512 512">
				<path
					fill="#A09FA7"
					d="M76 16C36 36 31 46 31 46c40 160 5 275-15 375c0 0 10 25 90 45V256c0-80-30-240-30-240m360 0s-30 160-30 240v210c80-20 90-45 90-45c-20-100-55-215-15-375c0 0-5-10-45-30M226 196c-40 0-90 15-90 15v270s50 15 90 15h60c40 0 90-15 90-15V211s-50-15-90-15z"
				/>
			</svg>
		</div>
	);
};
